import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const AUTH_PATHS = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/google/session"];
const isAuthPath = (url = "") => AUTH_PATHS.some((p) => url.includes(p));

const redirectToLogin = () => {
  const { pathname, search } = window.location;
  if (pathname.startsWith("/auth")) return;
  if (!pathname.startsWith("/app") && !pathname.startsWith("/onboarding")) return;
  window.location.assign(`/auth?returnTo=${encodeURIComponent(pathname + search)}`);
};

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (response?.status !== 401 || !config || config._retried || isAuthPath(config.url)) {
      return Promise.reject(error);
    }
    config._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => {
          refreshPromise = null;
        });
      }
      await refreshPromise;
      return api(config);
    } catch {
      redirectToLogin();
      return Promise.reject(error);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
